import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { domainStatusParser } from '#validation/workspace/parsers';
import { verifiedDomainConfigResponseSchema } from './verified-domain-config-response.dto';
export const organizationDomainResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    verification: z.object({
        status: domainStatusParser,
        method: z.string().nullable(),
        value: z.string().nullable(),
    }),
    verifiedDomainConfig: verifiedDomainConfigResponseSchema.nullish(),
    verifiedInWorkspacesCount: z.number().optional(),
});
export class OrganizationDomainResponseDto extends createZodDto(organizationDomainResponseSchema) {
}
